<template>
  <div>
    <div class="d-flex justify-end mb-3">
      <v-btn variant="outlined" size="small" :loading="loading" @click="load">
        Yenile
      </v-btn>
    </div>

    <v-alert v-if="error" type="error" class="mb-4" closable @click:close="error = null">
      {{ error }}
    </v-alert>

    <v-row v-if="stats">
      <v-col cols="12" sm="4">
        <v-card variant="tonal" color="primary">
          <v-card-text class="text-center">
            <div class="text-h4 font-weight-bold">{{ stats.total.toLocaleString() }}</div>
            <div class="text-body-2 mt-1">Toplam Chunk</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <v-card variant="tonal" color="success">
          <v-card-text class="text-center">
            <div class="text-h4 font-weight-bold">{{ stats.laws.toLocaleString() }}</div>
            <div class="text-body-2 mt-1">Yasa / Tüzük</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <v-card variant="tonal" color="info">
          <v-card-text class="text-center">
            <div class="text-h4 font-weight-bold">{{ stats.cases.toLocaleString() }}</div>
            <div class="text-body-2 mt-1">Mahkeme Kararı</div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card>
          <v-card-title class="text-body-1">Karar Zenginleştirme</v-card-title>
          <v-card-text>
            <div class="d-flex justify-space-between mb-1 text-body-2">
              <span>{{ stats.cases_enriched.toLocaleString() }} / {{ stats.cases.toLocaleString() }}</span>
              <span>{{ enrichPercent }}%</span>
            </div>
            <v-progress-linear :model-value="enrichPercent" color="primary" rounded height="8" />
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6">
        <v-card>
          <v-card-text>
            <div class="text-overline">BM25 İndeks Boyutu</div>
            <div class="text-h6">{{ stats.bm25_size_mb }} MB</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card>
          <v-card-text>
            <div class="text-overline">Son İndeks Zamanı</div>
            <div class="text-h6">{{ stats.last_indexed ? new Date(stats.last_indexed).toLocaleString('tr-TR') : '—' }}</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-else-if="loading">
      <v-col v-for="n in 3" :key="n" cols="12" sm="4">
        <v-skeleton-loader type="card" />
      </v-col>
    </v-row>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import axios from '@/plugins/axios'

const API_BASE = process.env.VUE_APP_API_BASE_URL as string

interface Stats {
  total: number
  laws: number
  cases: number
  cases_enriched: number
  bm25_size_mb: number
  last_indexed: string | null
}

const stats   = ref<Stats | null>(null)
const loading = ref(false)
const error   = ref<string | null>(null)

const enrichPercent = computed(() => {
  if (!stats.value || stats.value.cases === 0) return 0
  return Math.round((stats.value.cases_enriched / stats.value.cases) * 100)
})

async function load() {
  loading.value = true
  error.value   = null
  try {
    const res = await axios.get(`${API_BASE}/admin/parser/stats`)
    stats.value = res.data
  } catch (e: any) {
    error.value = e?.response?.data?.error ?? e?.message ?? 'Hata'
  } finally {
    loading.value = false
  }
}

onMounted(load)
</script>
